import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "p-form-search__button__icon" }
const _hoisted_2 = {
  key: 1,
  class: "p-form-search"
}
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = { class: "p-form-search__button__icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_IconSearch = _resolveComponent("IconSearch")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _component_SuggestPanel = _resolveComponent("SuggestPanel")!

  return (_openBlock(), _createElementBlock("form", {
    name: "formSearch",
    onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"]))
  }, [
    (_ctx.suggestType)
      ? (_openBlock(), _createBlock(_component_SuggestPanel, {
          key: 0,
          modelValue: _ctx.internalSearch,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.internalSearch) = $event)),
          class: "p-form-search__suggest_panel",
          type: _ctx.suggestType
        }, {
          default: _withCtx(() => [
            _createVNode(_component_InputText, {
              modelValue: _ctx.internalSearch,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.internalSearch) = $event)),
              type: "search",
              class: "p-form-search__suggest_panel__input",
              name: "internalSearch",
              placeholder: _ctx.placeholder,
              autocomplete: "off",
              "has-icon": true
            }, null, 8, ["modelValue", "placeholder"]),
            _createElementVNode("button", {
              type: "submit",
              class: "p-form-search__button p-form-search__button--has_saggest",
              style: _normalizeStyle({ background: _ctx.buttonColor }),
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.emitSearchMember && _ctx.emitSearchMember(...args)))
            }, [
              _createElementVNode("i", _hoisted_1, [
                _createVNode(_component_IconBase, {
                  width: 24,
                  height: 24,
                  "view-box": "0 0 24 24",
                  "icon-color": _ctx.buttonColor ? '#ffffff' : _ctx.iconColor
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconSearch, { "icon-size": 24 })
                  ]),
                  _: 1
                }, 8, ["icon-color"])
              ]),
              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "p-form-search__button__text" }, "検索", -1))
            ], 4)
          ]),
          _: 1
        }, 8, ["modelValue", "type"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.internalSearch) = $event)),
            type: "text",
            class: "p-form-search__input",
            placeholder: _ctx.placeholder
          }, null, 8, _hoisted_3), [
            [_vModelText, _ctx.internalSearch]
          ]),
          _createElementVNode("button", {
            type: "submit",
            class: "p-form-search__button",
            style: _normalizeStyle({ background: _ctx.buttonColor }),
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.emitSearchMember && _ctx.emitSearchMember(...args)))
          }, [
            _createElementVNode("i", _hoisted_4, [
              _createVNode(_component_IconBase, {
                width: 24,
                height: 24,
                "view-box": "0 0 24 24",
                "icon-color": _ctx.buttonColor ? '#ffffff' : _ctx.iconColor
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_IconSearch, { "icon-size": 24 })
                ]),
                _: 1
              }, 8, ["icon-color"])
            ]),
            _cache[7] || (_cache[7] = _createElementVNode("span", { class: "p-form-search__button__text" }, "検索", -1))
          ], 4)
        ]))
  ], 32))
}